import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
  },
  // "Fura" o container centralizado (maxWidth do GuestsMainLayout) e ocupa a
  // largura total da viewport. Usar apenas em layouts SEM menu lateral (guest).
  fullBleed: {
    position: 'relative',
    left: '50%',
    right: '50%',
    width: '100vw',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    boxSizing: 'border-box',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    padding: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  content: {
    padding: theme.spacing(3),
  },
  confirmBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    backgroundColor: theme.palette.lightPastelBlue,
    border: `1px solid ${theme.palette.lightBorder}`,
    borderRadius: 12,
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(2),
  },
  confirmTitle: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  confirmText: {
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
}))

export default useStyles
